<script>
	import Scroller from "@sveltejs/svelte-scroller";
	import { fade } from "svelte/transition";
	import { onMount } from 'svelte';

	import { scaleLinear } from "d3-scale";

	import SizeDetector from "./components/SizeDetector.svelte";
	import MediaQuery from "./components/MediaQuerySsr.svelte";
	import Section from "./components/Section.svelte";
	import Background from "./components/Background.svelte";
	import Pagination from "./components/Pagination.svelte";

	import { width, height } from "./stores";
	import { sections } from "./config";

	// ///////////////////////////////////////////////////////////
	// props
	// ///////////////////////////////////////////////////////////
	export let name;

	// ///////////////////////////////////////////////////////////
	// media query variables
	// ///////////////////////////////////////////////////////////
	let breakpoint;
	let platform;
	let orientation;
	let mobile;
	let tablet;

	// ///////////////////////////////////////////////////////////
	// constants and definitions
	// ///////////////////////////////////////////////////////////
	let container;

	// ///////////////////////////////////////////////////////////
	// scroller variables
	// ///////////////////////////////////////////////////////////
	let count;
	let index;
	let sectionProgress;
	let progress;
	let top = 0;
	let threshold = 0.7;
	let bottom = 0;
	const maxSectionProgress = 0.5;

	let currentSectionObj = sections[0];

	$: currentSectionObj = sectionProgress && sectionProgress > 0 ? sections[index] : sections[0];
	$: currentSection = currentSectionObj && currentSectionObj.id;

	$: progressScale = scaleLinear().domain([0, maxSectionProgress]).range([0, 1]).clamp(true);
	$: scaledSectionProgress = progressScale(sectionProgress);

	// ///////////////////////////////////////////////////////////
	// loading animation
	// ///////////////////////////////////////////////////////////
	let isLoading = true;
	function loadingAnimation() {
		setTimeout(() => {
		isLoading = false;
		}, 600);
	}

	onMount(loadingAnimation);


	function scrollDown() {
		window.scrollTo({
		top: window.innerHeight,  // scroll down by one window height
		behavior: "smooth"  // add smooth scrolling animation
		});
	}

	// ///////////////////////////////////////////////////////////
	// debug
	// ///////////////////////////////////////////////////////////
	// $: console.log("section", currentSection, index, count, progress);

	// $: console.log("dimensions", $width, $height);

	$: showScrollPrompt = index === 0 && progress < 0.2;
</script>

<MediaQuery bind:breakpoint bind:platform bind:orientation bind:mobile bind:tablet />

<div class="scrolly" class:loading={isLoading} bind:this={container}>
	<Scroller {top} {threshold} {bottom} bind:count bind:index bind:offset={sectionProgress} bind:progress>
		<div slot="background">
			<SizeDetector bind:width={$width} bind:height={$height}>
				<Background {...currentSectionObj.background} {scaledSectionProgress} />
			</SizeDetector>
		</div>

		<div slot="foreground">
			{#each sections as section, i}
				<Section {...section.slide} id={section.id} height={section.height} current={section === currentSectionObj} />
			{/each}
		</div>
	</Scroller>
	<Pagination {sections} {index} {progress} />
	{#if showScrollPrompt}
		<div class="scroll-prompt" on:click={scrollDown} transition:fade>
			<div class="scroll-prompt__text">Scrollen</div>
			<svg class="scroll-prompt__icon" width="36" height="19" viewBox="0 0 36 19" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 1L18 18L35 1" stroke="white"/>
				</svg>
		</div>
	{/if}
</div>

<style lang="scss">
	.scrolly {
		font-family: $ff-serif;
		color: $offwhite;
		margin-bottom: 0;
		z-index: 0;
		position: relative;
		margin-bottom: calc(100vh + 60px);
		opacity: 1;
		transition: opacity 1.3s linear;

		&.loading {
			opacity: 0;
		}
	}

	.scroll-prompt {
		position: fixed;
		bottom: 20px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
		text-align: center;
		text-transform: uppercase;
		cursor: pointer;

		&__text {
			font-family: $ff-sans;
			font-size: 18px;
			line-height: 23px;
			letter-spacing: 0.1em;
			margin-bottom: 10px;
		
			@media (max-width: $breakpoint-mobile) {
				font-size: 14px;
				line-height: 18px;
				margin-bottom: 5px;
			}
		}

		&__icon {
			@media (max-width: $breakpoint-mobile) {
				height: 11px;
			}
		}
	}

	// ///////////////////////////////////////////////////////////
	// scroller
	// ///////////////////////////////////////////////////////////
	[slot="background"] {
		overflow: hidden;
		height: 100vh;
	}

	// [slot="foreground"] {
	// 	pointer-events: none;
	// }

	// ///////////////////////////////////////////////////////////
	// breakpoints
	// ///////////////////////////////////////////////////////////

	// desktop
	@media (min-width: #{$breakpoint-tablet + 1px}) {
	}

	// tablets
	@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
	}

	// phones
	@media (max-width: $breakpoint-mobile) {
	}
</style>
